import { actionKey } from './constants';
import { createAction } from 'redux-actions';
export var logPageView = createAction("".concat(actionKey, "/LOG_PAGEVIEW"), function (payload) { return payload; });
//# sourceMappingURL=actions.js.map